import { makeAutoObservable } from 'mobx';

class AccountStore {
  isDoctor = false;

  get isDrugStore() {
    return !this.isDoctor;
  }

  constructor() {
    makeAutoObservable(this);
  }

  setIsDoctor(value: boolean) {
    this.isDoctor = value;
  }
}

export default new AccountStore();
